import React, { useState } from "react";
import { Box, TextField, Button, Typography, Container } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom"; // Use useNavigate for v6
import { resendOtp, verifyOtp } from "../../apis/apisList/userApi";
import { useApp } from "../../Context/AppContext";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Verification = () => {
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({ otp: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate(); // Initialize navigate for navigation
  const [searchParams] = useSearchParams();
  const redirectPage = searchParams.get("redirect");
  const { login } = useApp();
  const validateForm = () => {
    const newErrors = {};
    if (!otp) {
      newErrors.otp = "OTP is required.";
    } else if (!/^\d{6}$/.test(otp)) {
      newErrors.otp = "OTP must be 6 digits";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      try {
        const email = localStorage.getItem("temp_user");
        const response = await verifyOtp({ otp, email });
        toast.success("Verification successful");
        login(response);
        const redirect = redirectPage
          ? redirectPage.startsWith("/")
            ? redirectPage
            : `/${redirectPage}`
          : "/dashboard";
        localStorage.removeItem("temp_user");
        navigate(redirect);
      } catch (error) {
        const message =
          error.response.data.message ||
          "Something went wrong. Please try again.";
        console.error("Error during verification request:", error);
        // Handle network or server error
        setErrors({ otp: message });
      }
    }
  };
  const handleResend = async () => {
    try {
      const email = localStorage.getItem("temp_user");
      const response = await resendOtp({ email });
      toast.success("Verification OTP sent to your email");
    } catch (error) {
      const message =
        error.response.data.message ||
        "Something went wrong. Please try again.";
      console.error("Error during handleResend request:", error);
      // Handle network or server error
      setErrors({ otp: message });
    }
  };

  const login_style = {
    title: {
      fontSize: "24px",
      fontWeight: "600",
    },
    loginBtn: {
      backgroundColor: "#065F9C",
      boxShadow: "none",
      borderRadius: "10px",
      padding: "12px 20px",
      fontSize: "20px",
      fontWeight: "500",
      textTransform: "inherit",
    },
  };
  const auth_box = {
    logRegBox: {
      // display: "flex",
      // padding: "60px 60px 30px 60px",
    },
    loginCol: {
      // width: "47%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    signupCol: {
      // width: "47%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    orDividertxt: {
      height: "80px",
      width: "100%",
      textAlign: "center",
      background: "#FFF",
      lineHeight: "1.4",
      padding: "5px",
      fontSize: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "1",
      fontStyle: "italic",
    },
    captchaTxt: {
      fontSize: "14px",
      textAlign: "center",
      fontWeight: "500",
      letterSpacing: "0.3px",
      color: "#333333",
      marginBottom: "65px",
    },
    cantLogin: {
      fontSize: "16px",
      color: "#333333",
      fontWeight: "600",
      letterSpacing: "0px",
    },
  };

  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame">
        <Box className="backBtnFrame">
          <Button
            className="backBtn"
            variant="contained"
            sx={{ marginBottom: 2 }}
            onClick={() => (window.location.href = "/")}
          >
            <ArrowBackIcon sx={{ marginRight: 1 }} />
            Back to Homepage
          </Button>
        </Box>

        <Box
          style={auth_box.logRegBox}
          sx={{
            display: { xs: "block", sm: "block", md: "flex" },
            padding: {
              xs: "30px 30px 30px 30px",
              sm: "30px 30px 30px 30px",
              md: "60px 60px 30px 60px",
            },
          }}
        >
          <Box
            style={auth_box.loginCol}
            sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}
          >
            <Box sx={{ width: "100%", maxWidth: "355px", margin: "20px auto" }}>
              <Typography
                style={login_style.title}
                variant="h6"
                align="center"
                sx={{ marginBottom: 4, paddingBottom: 2, borderBottom: 2 }}
              >
                Email Verification
              </Typography>
              <Typography
                variant="body1"
                align="center"
                sx={{ marginBottom: 3, color: "#666" }}
              >
                Please enter the Verification Code we sent to your email
                address.
              </Typography>

              <TextField
                label="Verification Code"
                variant="outlined"
                fullWidth
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                  setErrors({ ...errors, otp: "" }); // Clear the error message
                }}
                error={!!errors.otp} // Display error state
                helperText={errors.otp} // Display error message
                sx={{
                  marginBottom: 3,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px", // Apply borderRadius here
                  },
                  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                  "& input[type=number]": {
                    MozAppearance: "textfield", // Firefox
                  },
                }}
                type="number"
              />

              {successMessage && (
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ marginBottom: 3, color: "green" }}
                >
                  {successMessage}
                </Typography>
              )}
              <Button
                style={login_style.loginBtn}
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                sx={{ marginBottom: 0 }}
              >
                Submit
              </Button>
              <Button
                fullWidth
                onClick={handleResend} // Redirect to the login page
                sx={{
                  marginTop: 2,
                  textTransform: "inherit",
                  color: "#065F9C",
                }}
              >
                Resend Verification Code
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Verification;
